// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .custom-select {
  position: relative;
    width: 120px;
    background-color: #ffffff;
    padding: 8px 5px 5px;
    border: 0.5px solid #48484833;
    border-radius: 4px;
    opacity: 1;
    display: flex;
    cursor: pointer;
  }

  .custom-select h1 {
    font-size: 9px;
    font-weight: 100;
    margin-bottom: 3px;
    color: #A0A0A0;
  }

  .custom-select .dropdown {
    font-size: 12px;
    color: #6A6A6A;
    font-weight: 600;
  }

  .custom-select .dropdown-menu {
    left: 0;
    top: 46px;
    min-width: 120px;
    height: auto;
    overflow: auto;
  }

  .custom-select .dropdown-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: auto;
  }

  .custom-select .show {
    display: block;
    z-index: 10;
  }

  .custom-select .dropdown-item {
     font-size: 10px;
  }


   */

.custom-select {
  position: relative;
  display: inline-block;
  cursor: pointer;
  font-family: Arial, sans-serif;
  width: 100%;
  color: rgb(119, 119, 119);
}

.custom-select h1 {
  font-size: 10px;
  font-weight: 100;
  margin-bottom: 3px;
  color: #a0a0a0;
}

.dropdown {
  font-size: 12px;
  display: flex;
  align-items: center;
  padding: 6px 10px;
  background-color: #ffffff;
  border: 0.5px solid #48484833;
  border-radius: 4px;
}

.dropdown h1 {
  margin: 0;
  margin-right: 10px;
}

.dropdown-icon {
  margin-left: auto;
  padding: 0px;
}

.dropdown-menu-list {
  display: none;
  position: absolute;
  width: 100%;
  max-height: 200px;
  overflow: auto;
  top: 100%;
  left: 0;
  z-index: 1;
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.dropdown-menu-list.show {
  display: block;
}

.dropdown-item {
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 12px;
  border-bottom: 1px solid #e1e1e1;
}

.dropdown-item:hover {
  background-color: #b0aeae;
}
`, "",{"version":3,"sources":["webpack://./src/components/customSelect/CustomSelect.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAkDI;;AAEJ;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,8BAA8B;EAC9B,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,OAAO;EACP,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* .custom-select {\n  position: relative;\n    width: 120px;\n    background-color: #ffffff;\n    padding: 8px 5px 5px;\n    border: 0.5px solid #48484833;\n    border-radius: 4px;\n    opacity: 1;\n    display: flex;\n    cursor: pointer;\n  }\n\n  .custom-select h1 {\n    font-size: 9px;\n    font-weight: 100;\n    margin-bottom: 3px;\n    color: #A0A0A0;\n  }\n\n  .custom-select .dropdown {\n    font-size: 12px;\n    color: #6A6A6A;\n    font-weight: 600;\n  }\n\n  .custom-select .dropdown-menu {\n    left: 0;\n    top: 46px;\n    min-width: 120px;\n    height: auto;\n    overflow: auto;\n  }\n\n  .custom-select .dropdown-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: auto;\n  }\n\n  .custom-select .show {\n    display: block;\n    z-index: 10;\n  }\n\n  .custom-select .dropdown-item {\n     font-size: 10px;\n  }\n\n\n   */\n\n.custom-select {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n  font-family: Arial, sans-serif;\n  width: 100%;\n  color: rgb(119, 119, 119);\n}\n\n.custom-select h1 {\n  font-size: 10px;\n  font-weight: 100;\n  margin-bottom: 3px;\n  color: #a0a0a0;\n}\n\n.dropdown {\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  padding: 6px 10px;\n  background-color: #ffffff;\n  border: 0.5px solid #48484833;\n  border-radius: 4px;\n}\n\n.dropdown h1 {\n  margin: 0;\n  margin-right: 10px;\n}\n\n.dropdown-icon {\n  margin-left: auto;\n  padding: 0px;\n}\n\n.dropdown-menu-list {\n  display: none;\n  position: absolute;\n  width: 100%;\n  max-height: 200px;\n  overflow: auto;\n  top: 100%;\n  left: 0;\n  z-index: 1;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.dropdown-menu-list.show {\n  display: block;\n}\n\n.dropdown-item {\n  padding: 10px;\n  width: 100%;\n  box-sizing: border-box;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  font-size: 12px;\n  border-bottom: 1px solid #e1e1e1;\n}\n\n.dropdown-item:hover {\n  background-color: #b0aeae;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
